import { Autocomplete, Grid, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";


const OutletItemBreakupsReport = () => {
    const classes = useStyle()
    const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [catData,setCatData] = useState([])
  const [subData,setSubData] = useState([])
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
  const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
  const [dateLimit, setDateLimit] = useState({
    fromDate : moment().subtract(1 , "months").format(),
    toDate :  moment().format()
  })
  const [options, setOptions] = useState({
    customer : null,
    category : null,
    subCategory : null
})

function handleOptions(value, name){
    console.log(name, value)
    setOptions(prev=>({...prev,[name] : value}))
}
const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 70,
    maxWidth : 100,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
  {
    field: "date",
    headerName: "Date",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "code",
    headerName: "Product Code",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "item",
    headerName: "Product Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "qty",
    headerName: "Qty",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "amt",
    headerName: "Amount",
    flex: 1,
    headerAlign: "center",
    align: "right",
    sortable: false,
    renderCell: (params) => (
      <strong>{params.value}</strong>
    ),
  },
]
console.log(data)
const rows = _.map(data,(val,idx)=>({
  id: idx + 1,
  sno: idx + 1,
  code : val.pro_code,
  item : val.pro_name,
  qty : val.qty,
  amt : parseFloat(val.amount).toFixed(2),
  date:moment(val.docdate).format('DD-MM-YYYY')
}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag
}
useEffect(() => {
  // Calculate total balance amount
  setTotalFlag(true)
  let total = 0;

  data.forEach(val => {
      total += parseFloat(val.amount);
  });
  setTotalAmount(total.toFixed(2));
}, [data]);
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        console.log(res.data)
        setSupplier(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  function getCategory(){
    axios.get('/v1/categories')
    .then(res=>{
        _.filter(res.data, val=>{
            if(val.is_active){
                 setCatData(res.data)
            }
        })
    })
    .catch(err=>{
        console.log(err.response.data.error)
        dispatch(setSnackbar(true,'error',err.response.data.error))
    })
}
function getSubCategory(){
    axios.get('/v1/subcategories')
    .then(res=>{
            setSubData(res.data)
    })
    .catch(err=>{
        console.log(err.response.data.error)
        dispatch(setSnackbar(true,'error',err.response.data.error))
    })
}
function handleOutletSalesBreakups(){
  const postData = {
    from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
    to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
      customer: options.customer !==null ? options.customer.id : 0,
      category : options.category !==null ? options.category.id : 0,
      subcategory : options.subCategory !==null ? options.subCategory.id : 0
  }
  axios.post('/v1/reports/outlet_sales/itemwise/breakups', postData)
  .then(res=>{
    setData(res.data)
    console.log(res)
    setPageCount(res.data.length)
  })
  .catch(err=>{
    setData([])
    dispatch(setSnackbar(true, "error", err.response.data.error));
  })
}
  useEffect(() => {
    getSupplierData();
    getCategory()
    getSubCategory()
  }, []);
  
  useEffect(()=>{
    if(dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handleOutletSalesBreakups()
      console.log('Vanthuden')
    }
  },[rowsPerPage, page, dateLimit,options])
  return (
  <Fragment>
    <Helmet><title>Outlet Sales Itemwise Breakups Reports</title></Helmet>
   <Typography variant="h6">Outlet Sales Itemwise Breakups Reports</Typography>
   <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete 
            size="small"
            options={[{id:0 , fullname :"All"} , ...supplier]}
            onChange={(e,value)=>handleOptions(value,'customer')}
            getOptionLabel={option=>option.fullname}
            renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
          />
        </Grid>
        <Grid item md={3}>
      <Autocomplete 
        size='small'
        value={options.category}
        options={catData}
        getOptionLabel={option=>option.category_name}
        onChange={(e,value)=>handleOptions(value,'category')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Category'/>
          )}
        />
      </Grid>
      <Grid item md={3}>
      <Autocomplete 
        size='small'
        options={subData}
        value={options.subCategory}
        getOptionLabel={option=>option.subcategory_name}
        onChange={(e,value)=>handleOptions(value,'subCategory')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Sub Category'/>
          )}
        />
      </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <CustomTable props={props}/>
  </Fragment>
  )
}

export default memo(OutletItemBreakupsReport)